import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { SpriteConstant } from 'src/app/constant/sprite.constant';

@Component({
    selector: 'app-relaxpopupalert',
    templateUrl: './relaxPopupAlert.layout.mobile.component.html',
    styleUrls: ['../css/relaxPopupAlert.layout.mobile.component.scss'],
    standalone: false
})
export class relaxPopupAlertComponent {
  @Input() alertData: any;
  @Output() relaxeventEmit: EventEmitter<any> = new EventEmitter<any>();
  menu_icons: any;
  LDSeatsObj: any;
  popUpTo: any;
  currentLanguage: any = 'en';
  version = '';
  constructor() {
    this.menu_icons = SpriteConstant.MENU_ICONS;
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }

  onCloseClick = (event = null) => {
    let objClick: any = {};
    objClick.status = 'close';
    this.relaxeventEmit.emit(objClick);
    console.log('this.relaxeventEmit', this.relaxeventEmit);
  };
  /* onRedirectClick = (LDSeatsObj) => {

    let objClick:any = {};
    objClick.status = 'redirect';
    objClick.LDSeatsObj = LDSeatsObj;
    this.eventEmit.emit(objClick);
  } */
  headerMessageText = 'none';
  descriptionMessageText = 'none';
  errorMessageCode = 'none';
  displayRelaxErrorCode(headerMessage) {
    console.log('displayRelaxErrorCode------headerMessage', headerMessage);

    switch (headerMessage) {
      case 'RELAX_FUN_ERROR':
        this.headerMessageText = 'LANG01115';
        this.descriptionMessageText = 'LANG01116';
        this.errorMessageCode = 'RG-10521';
        break;
      case 'INVALID_TOKEN':
        this.headerMessageText = 'LANG01119';
        this.descriptionMessageText = 'LANG00039';
        this.errorMessageCode = 'RG-10528';
        break;
      case 'BLOCKED_FROM_PRODUCT':
        this.headerMessageText = 'LANG01120';
        this.descriptionMessageText = 'LANG01083';
        this.errorMessageCode = 'RG-10528';
        break;
      case 'IP_BLOCKED':
        this.headerMessageText = 'LANG01121';
        this.descriptionMessageText = 'LANG01092';
        this.errorMessageCode = 'RG-10528';
        break;
      case 'UNHANDLED':
        this.headerMessageText = 'LANG01122';
        this.descriptionMessageText = 'LANG01089';
        this.errorMessageCode = 'RG-10528';
        break;
    }
  }

  ngOnInit() {
    if (this.alertData && this.alertData.currentLanguage) {
      this.currentLanguage = this.alertData.currentLanguage;
      //console.log("alertLiveDealerNoSeatAvailableComponent..",this.currentLanguage)
    }
    if (this.alertData.LDSeatsObj) {
      this.LDSeatsObj = this.alertData.LDSeatsObj;
    }
    if (this.alertData.popUpTo) {
      this.popUpTo = this.alertData.popUpTo;
    }
    this.displayRelaxErrorCode(this.popUpTo);
  }
  ngOnDestroy() {
    delete this.alertData;
    delete this.menu_icons;
    delete this.LDSeatsObj;
    delete this.currentLanguage;
    delete this.version;
  }
}
